<template>
  <section
    id="pricing"
    :class="$vuetify.theme.dark ? 'black' : 'white'"
    class="py-16"
  >
    <v-container>
      <v-row>
        <v-col>
          <v-row no-gutters>
            <v-col class="text-center">
              <h2
                class="text-h4 text-md-h3 text-center font-weight-black text-capitalize mb-4"
              >
                The most affordable pricing
              </h2>

              <p class="my-10 title">
                We offer a range of subscription plans for shipping companies
                that include different benefits, there are other plans for
                application developers, for details, contact us.
              </p>
              <div class="text-center">
                <v-btn-toggle
                  v-model="planDuration"
                  active-class="primary darken-1"
                  bpackageless
                  mandatory
                  light
                  color="white"
                >
                  <v-btn value="monthly"> Monthly Plan </v-btn>
                  <v-btn value="yearly"> Yearly Plan </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row class="mx-auto" style="max-width: 1200px">
        <v-col v-for="(plan, ix) in plans" :key="`plan-${ix}`" cols="12" md="4">
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 24 : plan.elevation"
              :color="plan.color"
              max-width="400"
              :class="hover ? 'zoom' : 'notzoom'"
              class="mx-auto transition-swing"
            >
              <h3
                class="text-h4 text-center font-weight-black white--text pt-5"
                v-text="plan.plan"
              ></h3>
              <v-card-text
                class="text-center subtitle-1 white--text py-2"
                v-text="plan.description"
              ></v-card-text>
              <v-card-subtitle
                class="text-h5 font-weight-black text-center white--text pt-0"
                >{{ planDuration === "monthly" ? plan.monthly : plan.yearly }}
                <span class="subtitle-1"
                  >per {{ planDuration === "monthly" ? "month" : "year" }}</span
                ></v-card-subtitle
              >
              <v-list>
                <v-list-item
                  v-for="(feature, ik) in plan.features"
                  :key="`feature-${ik}`"
                  dense
                >
                  <v-list-item-icon>
                    <v-icon>
                      {{ feature.icon }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      class="text-capitalize"
                      v-text="feature.text"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <!-- <v-btn
                    :to="'/register?plan=' + plan.plan"
                    :color="plan.color"
                    large
                    dark
                    block
                    rounded
                    class="mx-auto my-3"
                  >
                    get plan
                  </v-btn> -->
                </v-list-item>
              </v-list>
            </v-card></v-hover
          >
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  data() {
    return {
      planDuration: "monthly",
      plans: [
        {
          plan: "Starter",
          elevation: 0,
          color: "primary",
          description: "Best Plan for Small Businesses",
          monthly: "29.99 €",
          yearly: "329.99 €",
          features: [
            {
              icon: "mdi-calendar-month",
              text: " 1 month for free",
            },
            {
              icon: "mdi-clock-fast",
              text: "without V - Fast ",
            },
            {
              icon: "mdi-store",
              text: "1 branch",
            },
            {
              icon: "mdi-android",
              text: "Android appliction for delivery employees",
            },
            {
              icon: "mdi-crosshairs-gps",
              text: "without track packages live",
            },
            {
              icon: "mdi-link",
              text: "Share external links with clients",
            },
            {
              icon: "mdi-account-group",
              text: "without track employees live",
            },
            {
              icon: "mdi-chart-areaspline",
              text: "monthly Excel report",
            },
            {
              icon: "mdi-message",
              text: "Push messages and alert",
            },
            {
              icon: "mdi-account-multiple-check",
              text: "5 employee accounts",
            },

            {
              icon: "mdi-api",
              text: "Without  API , SDK interface",
            },
          ],
        },
        {
          plan: "Professional",
          elevation: 16,
          color: "green darken-2",
          description: "Best Plan for Professional Users",
          monthly: "49.99 €",
          yearly: "549.99 €",
          features: [
            {
              icon: "mdi-calendar-month",
              text: " 1 month for free",
            },
            {
              icon: "mdi-clock-fast",
              text: "  V - Fast ",
            },
            {
              icon: "mdi-store",
              text: "2 branch",
            },
            {
              icon: "mdi-android",
              text: "Android appliction for delivery employees",
            },
            {
              icon: "mdi-crosshairs-gps",
              text: "without track packages live",
            },
            {
              icon: "mdi-link",
              text: "Share external links with clients",
            },
            {
              icon: "mdi-account-group",
              text: "without track employees live",
            },
            {
              icon: "mdi-chart-areaspline",
              text: "weekly Excel report",
            },
            {
              icon: "mdi-message",
              text: "Push messages and alert",
            },
            {
              icon: "mdi-account-multiple-check",
              text: "20 employee accounts",
            },

            {
              icon: "mdi-api",
              text: "Without  API , SDK interface",
            },
          ],
        },
        {
          plan: "Businesses",
          elevation: 0,
          color: "#8E24AA",
          description: "Best Plan for  Professional Businesses",
          monthly: "99.99 €",
          yearly: "999.99 €",
          features: [
            {
              icon: "mdi-calendar-month",
              text: " 1 month for free",
            },
            {
              icon: "mdi-clock-fast",
              text: "  V - Fast ",
            },
            {
              icon: "mdi-store",
              text: "4 branch",
            },
            {
              icon: "mdi-android",
              text: "Android appliction for delivery employees",
            },
            {
              icon: "mdi-crosshairs-gps",
              text: " Track packages live",
            },
            {
              icon: "mdi-link",
              text: "Share external links with clients",
            },
            {
              icon: "mdi-account-group",
              text: "Track employees live",
            },
            {
              icon: "mdi-chart-areaspline",
              text: "Daily Excel report",
            },
            {
              icon: "mdi-message",
              text: "Push messages and alert",
            },
            {
              icon: "mdi-account-multiple-check",
              text: "50 employee accounts",
            },

            {
              icon: "mdi-api",
              text: "1000 requests per month API , SDK interface",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.zoom {
  transform: scale(1.025) translate(0, -10px);
  transition: transform 0.2s;
}
.notzoom {
  transition: transform 0.2s;
}
</style>
